import type { Service } from "../types";

export const services: Service[] = [
  {
    id: "pharmacy",
    name: "Pharmacy",
    tagline: "Round-the-clock Access to Trusted Medicines",
    icon: "Pill",
    shortDescription:
      "In-house 24/7 pharmacy stocking a comprehensive range of prescription and over-the-counter medicines.",
    fullDescription:
      "The Shifa Medical Centre pharmacy operates 24 hours a day, 7 days a week, so patients and their families always have access to the medicines they need. Our clinical pharmacists validate every prescription for dosage accuracy and drug interactions, and are available to counsel patients on how to take their medication safely. We stock a wide range of branded and generic medicines, surgical consumables, and specialty drugs, all sourced from licensed distributors and stored under strict temperature and quality controls.",
    features: [
      "Open 24/7 including Sundays and holidays",
      "Prescription validation by clinical pharmacists",
      "Branded and generic medicines",
      "Cold-chain storage for temperature-sensitive drugs",
      "Surgical consumables and medical supplies",
      "Medication counseling and dosage guidance",
      "Home delivery for in-patient discharge prescriptions",
      "Transparent pricing with itemised bills",
    ],
    timing: "Open 24 hours, all days",
  },
  {
    id: "radiology",
    name: "Radiology",
    tagline: "Precise Imaging for Faster Diagnosis",
    icon: "ScanLine",
    shortDescription:
      "Advanced diagnostic imaging including digital X-ray, ultrasound, CT scan, and MRI with rapid reporting.",
    fullDescription:
      "Our Radiology & Imaging department is equipped with modern diagnostic technology to support every clinical specialty at Shifa Medical Centre. From routine digital X-rays and ultrasound to CT and MRI scans, our experienced radiologists deliver accurate, timely reports that help your doctors make confident treatment decisions. All images are stored digitally and shared directly with your consulting physician, so there is no waiting for films or lost reports.",
    features: [
      "Digital X-ray with low radiation dose",
      "Ultrasound and colour Doppler studies",
      "CT scan with contrast studies",
      "MRI for neurological, spinal and joint imaging",
      "Obstetric and antenatal scans",
      "Image-guided biopsies and procedures",
      "Same-day reporting for most studies",
      "Digital reports shared with your doctor",
    ],
    timing: "Mon - Sat: 8:00 AM - 8:00 PM | Emergency imaging 24/7",
  },
  {
    id: "laboratory",
    name: "Laboratory",
    tagline: "Accurate Results You Can Rely On",
    icon: "FlaskConical",
    shortDescription:
      "Fully equipped diagnostic laboratory offering pathology, biochemistry, microbiology, and haematology tests with fast digital reports.",
    fullDescription:
      "The diagnostic laboratory at Shifa Medical Centre supports every department with a comprehensive menu of tests covering clinical pathology, biochemistry, microbiology, haematology, and serology. Samples are processed on automated analysers under strict quality-control protocols, and results are reviewed by qualified pathologists before release. Reports are generated digitally and shared with your consulting doctor, with most routine tests reported the same day. Home sample collection is available for patients who cannot visit the centre.",
    features: [
      "Complete blood count and haematology panels",
      "Biochemistry including liver, kidney, lipid and thyroid profiles",
      "Diabetes monitoring: blood sugar and HbA1c",
      "Microbiology cultures and sensitivity testing",
      "Serology and infectious disease screening",
      "Urine and stool analysis",
      "Same-day digital reports for routine tests",
      "Home sample collection on request",
    ],
    timing: "Mon - Sat: 7:00 AM - 8:00 PM | Emergency tests 24/7",
  },
  {
    id: "immunization",
    name: "Immunization",
    tagline: "Protecting Every Stage of Life",
    icon: "Syringe",
    shortDescription:
      "Complete vaccination services for infants, children, adults, and travellers following national immunization schedules.",
    fullDescription:
      "The Immunization service at Shifa Medical Centre provides safe, scheduled vaccinations for all age groups. We follow the national immunization schedule for infants and children, and offer adult vaccines, booster doses, and travel immunizations. All vaccines are stored in a monitored cold chain to preserve their potency, and are administered by trained nursing staff under physician supervision. We maintain digital vaccination records and send reminders so no dose is missed.",
    features: [
      "Infant and childhood vaccines as per national schedule",
      "Adult vaccines including influenza, hepatitis B and tetanus",
      "HPV and pneumococcal vaccination",
      "Travel vaccinations and certificates",
      "Booster doses and catch-up schedules",
      "Monitored cold-chain vaccine storage",
      "Digital vaccination records and dose reminders",
      "Post-vaccination observation and care",
    ],
    timing: "Mon - Sat: 9:00 AM - 5:00 PM",
  },
  {
    id: "blood-storage-unit",
    name: "Blood Storage Unit",
    tagline: "Safe Blood, Available When It Matters",
    icon: "Droplets",
    shortDescription:
      "Licensed blood storage unit ensuring screened, cross-matched blood is available for emergencies and surgeries.",
    fullDescription:
      "Our licensed Blood Storage Unit ensures that safe, screened blood and blood components are available round the clock for surgeries, trauma care, obstetric emergencies, and patients with chronic blood disorders. Every unit is sourced from licensed blood banks, screened for transfusion-transmissible infections, and stored in temperature-monitored refrigerators. Our trained technicians perform blood grouping and cross-matching on site so that compatible blood can be issued without delay.",
    features: [
      "24/7 availability for emergencies and surgeries",
      "Whole blood and packed red cells",
      "Blood grouping and cross-matching on site",
      "Screened units from licensed blood banks",
      "Temperature-monitored storage with alarms",
      "Support for thalassemia and hematology patients",
      "Coordination with blood banks for rare groups",
      "Strict transfusion safety protocols",
    ],
    timing: "Available 24 hours for emergencies",
  },
];
